import React, {Component} from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Container,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import home_banner from '../img/home_banner.png'
import home_banner2 from '../img/home_banner2.png'
import home_avatar1 from '../img/home_avatar1.png'
import home_avatar2 from '../img/home_avatar2.png'
import home_avatar3 from '../img/home_avatar3.png'
import home_avatar4 from '../img/home_avatar4.png'
import home_avatar5 from '../img/home_avatar5.png'
import home_avatar6 from '../img/home_avatar6.png'
import home_avatar7 from '../img/home_avatar7.png'
import home_avatar8 from '../img/home_avatar8.png'
import home_zz1 from '../img/home_zz1.png'
import home_zz2 from '../img/home_zz2.png'
import home_zz3 from '../img/home_zz3.png'
import home_zz4 from '../img/home_zz4.png'
import home_wlfw from '../img/home_wlfw.png'
import yy1 from '../img/yy1.png'
import yy2 from '../img/yy2.png'
import yy3 from '../img/yy3.png'
import yy4 from '../img/yy4.png'
import yy5 from '../img/yy5.png'
import yy6 from '../img/yy6.png'
import home_case1 from '../img/home_case1.jpg'
import home_news1 from '../img/home_news1.jpg'
import zysx from '../img/zysx.png'
import './all.css'


class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
   

    handleEnter = el=>{
        $('.'+el).css({'display':'block'})
    }
    handleOut = el=>{
        $('.'+el).css({'display':'none'})
    }
    render() {
        return (
            <div>
                <Row className='margin0'>
                    <Carousel >
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={home_banner}
                            alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                            className="d-block w-100"
                            src={home_banner2}
                            alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>润脉·健康握在你手中</h4>
                        <div style={{margin:'2% 0'}}>Raymedy·Health is in your hands</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={3}>
                        <img className="d-block w-100" src={zysx}/>
                    </Col>
                    <Col xs="auto" lg={5} className='home_fwwl'>
                        <div>Raymedy:</div>
                        <div>源于前苏联一批顶级科学家15年的研究，最早应用在太空为宇航员进行健康管理。 在欧洲已有20年临床运用实践经验，全球超过1000家专业医疗机构和诊所使用，以百分之95的推荐率成为全球能量医学之冠，备受世界能量医学界瞩目和专业人士的信服。</div>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>全球研发和运用合作专业团队</h4>
                        <div style={{margin:'2% 0'}}>Raymedy 一直得到领域内顶级权威科学家的鼎力支持</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover1')} onMouseLeave={()=>this.handleOut('hover1')}>
                            <img src={home_avatar1} className="d-block w-100"/>
                            <div className='rftl_item_title'>Prof. Dr. Gioacchino Falsone</div>
                            <div className='rftl_item_msg'>里雅斯特大学生物化学专业教授</div>
                            <div className='rftl_item_hover display_none hover1'>
                                <div className='rftl_item_hover_msg center'>Prof. Dr. Gioacchino Falsone 里雅斯特大学生物化学专业教授</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover2')} onMouseLeave={()=>this.handleOut('hover2')}>
                            <img src={home_avatar2} className="d-block w-100"/>
                            <div className='rftl_item_title'>Dr. med Cyrus Sami</div>
                            <div className='rftl_item_msg'>博士德国运动医学专家</div>
                            <div className='rftl_item_hover display_none hover2'>
                                <div className='rftl_item_hover_msg center'>Dr. med Cyrus Sami 博士德国运动医学专家在治疗慢性疼痛和运动损伤非常有名。2016 在慕尼黑大 学的讲演上，他说:“只有不到5％的情况，我无能 为力”。他为Raymedy在运动损伤康复提供了大量临床数据</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover3')} onMouseLeave={()=>this.handleOut('hover3')}>
                            <img src={home_avatar3} className="d-block w-100"/>
                            <div className='rftl_item_title'>Dr. Thomas Eberhard Heise</div>
                            <div className='rftl_item_msg'>德国著名心理专家,德国顶级中医</div>
                            <div className='rftl_item_hover display_none hover3'>
                                <div className='rftl_item_hover_msg center'>德国著名心理专家,德国顶级中医</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover4')} onMouseLeave={()=>this.handleOut('hover4')}>
                            <img src={home_avatar4} className="d-block w-100"/>
                            <div className='rftl_item_title'>Dr. med. Manfred Doepp</div>
                            <div className='rftl_item_msg'>德国知名能量医学和电针灸专家</div>
                            <div className='rftl_item_hover display_none hover4'>
                                <div className='rftl_item_hover_msg center'>德国知名能量医学和电针灸专家</div>
                            </div>
                        </div>
                    </Col>
                    
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover5')} onMouseLeave={()=>this.handleOut('hover5')}>
                            <img src={home_avatar5} className="d-block w-100"/>
                            <div className='rftl_item_title'>Dr. Kia Saatchi</div>
                            <div className='rftl_item_msg'>德黑兰中西医整合分院的联合创始人之一</div>
                            <div className='rftl_item_hover display_none hover5'>
                                <div className='rftl_item_hover_msg center'>德黑兰中西医整合分院的联合创始人之一</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover6')} onMouseLeave={()=>this.handleOut('hover6')}>
                            <img src={home_avatar6} className="d-block w-100"/>
                            <div className='rftl_item_title'>Prof.Dr. Jean WM Gardeniers</div>
                            <div className='rftl_item_msg'>荷兰知名外科整形专家</div>
                            <div className='rftl_item_hover display_none hover6'>
                                <div className='rftl_item_hover_msg center'>荷兰知名外科整形专家</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover7')} onMouseLeave={()=>this.handleOut('hover7')}>
                            <img src={home_avatar7} className="d-block w-100"/>
                            <div className='rftl_item_title'>Prof. Dr. Klaus Sedlbauer</div>
                            <div className='rftl_item_msg'>德国联邦环境局可持续建筑委员会的成员</div>
                            <div className='rftl_item_hover display_none hover7'>
                                <div className='rftl_item_hover_msg center'>德国联邦环境局可持续建筑委员会的成员</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover8')} onMouseLeave={()=>this.handleOut('hover8')}>
                            <img src={home_avatar8} className="d-block w-100"/>
                            <div className='rftl_item_title'>Prof. Dr. James. L. Oschman</div>
                            <div className='rftl_item_msg'>美国著名能量医学专家教授</div>
                            <div className='rftl_item_hover display_none hover8'>
                                <div className='rftl_item_hover_msg center'>美国著名能量医学专家教授</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>润脉服务网络</h4>
                        <div style={{margin:'2% 0'}}>Raymedy service network</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={5} className='home_fwwl'>
                        <div>
                        Raymedy1997年创始于荷兰，整合生物电磁学和西医病理学，运用现代科技手段和理念临床实践运用中医经脉学。以个体需求为核心，改善经脉功能为切入点，运用电磁波共振原理，充分发挥中医西医互补优势。<br/>
                       </div>
                        <div>Raymedy 最受世界能量医学界，专业人士青睐推荐的产品。</div>
                        <div>测量和干预系统经过科学评估和认可，2004年获欧洲医疗设备2A证书。</div>
                        <div>26个国家超过1000个专业医疗机构和诊所使用。</div>
                        <div>Raymedy系统，主要分布在德国， 荷兰、比利时、奥地利， 法国， 伊朗等等。</div>
                        <div>过去20年间，仅在德国就有超过400个私人 医疗机构/诊所先后使用Raymedy系统。</div>
                        <Button>联系服务网络</Button>
                    </Col>
                    <Col lg={3}>
                        <div>
                            <img src={home_wlfw} className="d-block w-60"/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>润脉·资质</h4>
                        <div style={{margin:'2% 0'}}>产品通过CE认证，调理设备通过IEC62471（光生物安全认证）<br/>IEC60601-1-10（神经与肌肉刺激器安全认证）
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={home_zz1} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={home_zz2} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item'>
                            <img src={home_zz3} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item'>
                            <img src={home_zz4} className="d-block w-100"/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>国家科技部重点研发课题</h4>
                        <div style={{margin:'2% 0'}}>基于大数据的人体健康管理系统在冠心病抗栓治疗中的应用</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={8}>
                        <h4 style={{marginTop:'3%'}}>课题介绍：</h4>
                        <div style={{margin:'2% 0'}}>
                                    以润脉智能健康系统为日常生活亚临床检测数据来源，融合医院信息系统的专业诊断资料，分析疾病模式，实现疾病预测以及个性化提前干预，从而在提高冠心病抗栓效果及降低出血风险方面取得突破，使出血、血栓净临床事件相对降低10%以上，相关方案纳入指南或临床规范。
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div>
                            <img src={yy1} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div>
                            <img src={yy2} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div>
                            <img src={yy3} className="d-block w-100"/>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div>
                            <img src={yy4} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div>
                            <img src={yy5} className="d-block w-100"/>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div>
                            <img src={yy6} className="d-block w-100"/>
                        </div>
                    </Col>
                </Row>
                <br></br>
                <br></br>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default Home;

